import { DataCard, Spacer } from "@qivia/ui";
import { colors } from "@qivia/ui/src/styles/figmaColors";
import { typographies } from "@qivia/ui/src/styles/figmaTypographies";
import { isSameMonth } from "date-fns";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { useAppSelector } from "../../../redux/hooks";
import { formatCurrency } from "../../../libSlice/materialUiFormats";
import {
  selectHomeChargingChargesMonths,
  selectHomeChargingSupportingDocumentsPeriod,
} from "./homeChargingSupportingDocumentsSlice";
import "../../../i18n/i18n";

export const SupportingDocumentsSummary = () => {
  const { t } = useTranslation();
  const months = useAppSelector(selectHomeChargingChargesMonths);
  const period = useAppSelector(selectHomeChargingSupportingDocumentsPeriod);

  const selectedMonthSummary = useMemo(
    () =>
      months.find(
        (monthSummary) =>
          period !== undefined &&
          isSameMonth(new Date(monthSummary.month), new Date(period.from)),
      ) ?? null,
    [months, period],
  );

  return (
    <StyledFlex>
      <StyledCardWrapper>
        <DataCard
          titleHeight=""
          title={
            <StyledCount>
              {selectedMonthSummary?.supportingDocumentsToCreateCount ?? 0}
            </StyledCount>
          }
          content={
            <StyledLabel>
              {t("home_charging_supporting_documents.recap.toCreate")}
            </StyledLabel>
          }
        />
      </StyledCardWrapper>
      <Spacer x={1} />
      <StyledCardWrapper>
        <DataCard
          titleHeight=""
          title={
            <StyledCount>
              {formatCurrency(selectedMonthSummary?.amountToJustify ?? 0)}
            </StyledCount>
          }
          content={
            <StyledLabel>
              {t("home_charging_supporting_documents.recap.amountToJustify")}
            </StyledLabel>
          }
        />
      </StyledCardWrapper>
      <Spacer x={1} />
      <StyledCardWrapper>
        <DataCard
          titleHeight=""
          title={
            <StyledCount>
              {selectedMonthSummary?.supportingDocumentsCount ?? 0}
            </StyledCount>
          }
          content={
            <StyledLabel>
              {t("home_charging_supporting_documents.recap.created")}
            </StyledLabel>
          }
        />
      </StyledCardWrapper>
    </StyledFlex>
  );
};

const StyledFlex = styled.div`
  display: flex;
`;

const StyledCardWrapper = styled.div`
  flex: 1;
  display: flex;
`;

const StyledCount = styled.div`
  ${typographies["Header/H1"]}
  color: ${colors["colors/text/black"]};
`;

const StyledLabel = styled.div`
  ${typographies["Body/M"]}
  color: ${colors["colors/text/darkGrey"]};
`;
